import { getIsDailyRent } from './getIsDailyRent';
import { TOfferCategory } from '../../../../types/offer';

export function getPaymentPeriod(category: TOfferCategory | null): string {
  return getIsDailyRent(category) ? 'сутки' : 'мес.';
}
